import { render, staticRenderFns } from "./ActivityMonitor.vue?vue&type=template&id=2fff4e64"
import script from "./ActivityMonitor.vue?vue&type=script&lang=js"
export * from "./ActivityMonitor.vue?vue&type=script&lang=js"
import style0 from "./ActivityMonitor.vue?vue&type=style&index=0&id=2fff4e64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports